import { inIframe } from '@/helpers';
import store from '@/store';
import registerAuto from './registerAuto';
import relog from './relog';

/**
 * @param {import("vue-router").Route} to
 * @param {import("vue-router").Route} from
 * @param {(any) => void} next
 */
export default function(to, from, next) {
  let sUid = ''
  if (inIframe()) {
    if (store.getters['user/stateParams'] && store.getters['user/stateParams'].sUid) {
      sUid = store.getters['user/stateParams'].sUid
    } else {
      sUid = window.localStorage.getItem("louisxiisession")
    }
  } else {
    if (to.query.sUid) {
      sUid = to.query.sUid
    } else if (store.getters['user/stateParams'] && store.getters['user/stateParams'].sUid) {
      sUid = store.getters['user/stateParams'].sUid
    } else {
      sUid = window.localStorage.getItem("louisxiisession")
    }
  }

  return relog(sUid)
    .then((pageID) => {
      if (
        to.query.e &&
        Number(to.query.insc) === 1 &&
        store.getters['config/activeDecliConfig'].optinisation.active
      ) {
        registerAuto(to, next);
      } else if (to.name !== 'OptinisationPage') {
        const activeDecliRoutes = store.getters['config/activeDecliRoutes'];
        const routeToRelog = activeDecliRoutes.find((route) => route.meta && route.meta.pageId === pageID);
        console.log('ROUTE', routeToRelog.name)

        // Remove the sUid before copy/paste
        const query = JSON.parse(JSON.stringify(to.query))
        delete query.sUid

        next({
          name: routeToRelog.name,
          query,
        });
      } else {
        next();
      }
    })
    .catch(console.log);
}